import { BorderRadius, Color, ComponentsGroup, getDefaultTransition, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import type { ColorToken } from '@shinetools/lumen-tokens/web/colors'
import transparentize from 'polished/lib/color/transparentize'

interface WrapperProps {
  autoHeight?: boolean
  highlighted?: boolean
  isLoading: boolean
  backgroundColor: Color | ColorToken
}

export const WidgetWrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ autoHeight }) => (autoHeight ? 'auto' : '270px')};
  padding: ${({ isLoading }) => (isLoading ? '0' : `${Spacing.S16} ${Spacing.S24} ${Spacing.S24}`)};
  border-radius: ${BorderRadius.R12};
  position: relative;
  background-color: ${({ backgroundColor }) => backgroundColor};
  box-shadow: ${({ highlighted }) => highlighted && `0 10px 70px ${transparentize(0.65, Color.Grey500)}`};
  ${getDefaultTransition('box-shadow')};
  ${({ backgroundColor }) => backgroundColor === Color.White && `border: 1px solid ${Color.Grey200}`};
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  margin-bottom: ${Spacing.S16};
  position: relative;
`
export const SideActions = styled.aside`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  padding-left: ${Spacing.S16};
`

export const TitleComponentsGroup = styled(ComponentsGroup)`
  align-items: baseline;
`
